/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OpenVulnCountSnapshot } from './OpenVulnCountSnapshot';
import {
    OpenVulnCountSnapshotFromJSON,
    OpenVulnCountSnapshotFromJSONTyped,
    OpenVulnCountSnapshotToJSON,
    OpenVulnCountSnapshotToJSONTyped,
} from './OpenVulnCountSnapshot';
import type { ContainerGraphEdgeDto } from './ContainerGraphEdgeDto';
import {
    ContainerGraphEdgeDtoFromJSON,
    ContainerGraphEdgeDtoFromJSONTyped,
    ContainerGraphEdgeDtoToJSON,
    ContainerGraphEdgeDtoToJSONTyped,
} from './ContainerGraphEdgeDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';
import type { BlastRadiusAssetDto } from './BlastRadiusAssetDto';
import {
    BlastRadiusAssetDtoFromJSON,
    BlastRadiusAssetDtoFromJSONTyped,
    BlastRadiusAssetDtoToJSON,
    BlastRadiusAssetDtoToJSONTyped,
} from './BlastRadiusAssetDto';
import type { UserHostGraphTraversalResponse } from './UserHostGraphTraversalResponse';
import {
    UserHostGraphTraversalResponseFromJSON,
    UserHostGraphTraversalResponseFromJSONTyped,
    UserHostGraphTraversalResponseToJSON,
    UserHostGraphTraversalResponseToJSONTyped,
} from './UserHostGraphTraversalResponse';

/**
 * 
 * @export
 * @interface VulnerabilityBlastRadiusResponse
 */
export interface VulnerabilityBlastRadiusResponse {
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityBlastRadiusResponse
     */
    cveId?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityBlastRadiusResponse
     */
    vulnerabilityDefinitionId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VulnerabilityBlastRadiusResponse
     */
    definitionResolved?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VulnerabilityBlastRadiusResponse
     */
    openFindingCount?: number;
    /**
     * 
     * @type {OpenVulnCountSnapshot}
     * @memberof VulnerabilityBlastRadiusResponse
     */
    severityBreakdown?: OpenVulnCountSnapshot;
    /**
     * 
     * @type {Array<BlastRadiusAssetDto>}
     * @memberof VulnerabilityBlastRadiusResponse
     */
    hosts?: Array<BlastRadiusAssetDto>;
    /**
     * 
     * @type {Array<BlastRadiusAssetDto>}
     * @memberof VulnerabilityBlastRadiusResponse
     */
    containerImages?: Array<BlastRadiusAssetDto>;
    /**
     * 
     * @type {Array<BlastRadiusAssetDto>}
     * @memberof VulnerabilityBlastRadiusResponse
     */
    containerWorkloads?: Array<BlastRadiusAssetDto>;
    /**
     * 
     * @type {Array<BlastRadiusAssetDto>}
     * @memberof VulnerabilityBlastRadiusResponse
     */
    derivedHosts?: Array<BlastRadiusAssetDto>;
    /**
     * 
     * @type {Array<ContainerGraphEdgeDto>}
     * @memberof VulnerabilityBlastRadiusResponse
     */
    graphEdges?: Array<ContainerGraphEdgeDto>;
    /**
     * 
     * @type {UserHostGraphTraversalResponse}
     * @memberof VulnerabilityBlastRadiusResponse
     */
    personTraversal?: UserHostGraphTraversalResponse;
    /**
     * 
     * @type {number}
     * @memberof VulnerabilityBlastRadiusResponse
     */
    queryDurationMs?: number;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityBlastRadiusResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof VulnerabilityBlastRadiusResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof VulnerabilityBlastRadiusResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof VulnerabilityBlastRadiusResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the VulnerabilityBlastRadiusResponse interface.
 */
export function instanceOfVulnerabilityBlastRadiusResponse(value: object): value is VulnerabilityBlastRadiusResponse {
    return true;
}

export function VulnerabilityBlastRadiusResponseFromJSON(json: any): VulnerabilityBlastRadiusResponse {
    return VulnerabilityBlastRadiusResponseFromJSONTyped(json, false);
}

export function VulnerabilityBlastRadiusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VulnerabilityBlastRadiusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'cveId': json['cveId'] == null ? undefined : json['cveId'],
        'vulnerabilityDefinitionId': json['vulnerabilityDefinitionId'] == null ? undefined : json['vulnerabilityDefinitionId'],
        'definitionResolved': json['definitionResolved'] == null ? undefined : json['definitionResolved'],
        'openFindingCount': json['openFindingCount'] == null ? undefined : json['openFindingCount'],
        'severityBreakdown': json['severityBreakdown'] == null ? undefined : OpenVulnCountSnapshotFromJSON(json['severityBreakdown']),
        'hosts': json['hosts'] == null ? undefined : ((json['hosts'] as Array<any>).map(BlastRadiusAssetDtoFromJSON)),
        'containerImages': json['containerImages'] == null ? undefined : ((json['containerImages'] as Array<any>).map(BlastRadiusAssetDtoFromJSON)),
        'containerWorkloads': json['containerWorkloads'] == null ? undefined : ((json['containerWorkloads'] as Array<any>).map(BlastRadiusAssetDtoFromJSON)),
        'derivedHosts': json['derivedHosts'] == null ? undefined : ((json['derivedHosts'] as Array<any>).map(BlastRadiusAssetDtoFromJSON)),
        'graphEdges': json['graphEdges'] == null ? undefined : ((json['graphEdges'] as Array<any>).map(ContainerGraphEdgeDtoFromJSON)),
        'personTraversal': json['personTraversal'] == null ? undefined : UserHostGraphTraversalResponseFromJSON(json['personTraversal']),
        'queryDurationMs': json['queryDurationMs'] == null ? undefined : json['queryDurationMs'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function VulnerabilityBlastRadiusResponseToJSON(json: any): VulnerabilityBlastRadiusResponse {
    return VulnerabilityBlastRadiusResponseToJSONTyped(json, false);
}

export function VulnerabilityBlastRadiusResponseToJSONTyped(value?: VulnerabilityBlastRadiusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cveId': value['cveId'],
        'vulnerabilityDefinitionId': value['vulnerabilityDefinitionId'],
        'definitionResolved': value['definitionResolved'],
        'openFindingCount': value['openFindingCount'],
        'severityBreakdown': OpenVulnCountSnapshotToJSON(value['severityBreakdown']),
        'hosts': value['hosts'] == null ? undefined : ((value['hosts'] as Array<any>).map(BlastRadiusAssetDtoToJSON)),
        'containerImages': value['containerImages'] == null ? undefined : ((value['containerImages'] as Array<any>).map(BlastRadiusAssetDtoToJSON)),
        'containerWorkloads': value['containerWorkloads'] == null ? undefined : ((value['containerWorkloads'] as Array<any>).map(BlastRadiusAssetDtoToJSON)),
        'derivedHosts': value['derivedHosts'] == null ? undefined : ((value['derivedHosts'] as Array<any>).map(BlastRadiusAssetDtoToJSON)),
        'graphEdges': value['graphEdges'] == null ? undefined : ((value['graphEdges'] as Array<any>).map(ContainerGraphEdgeDtoToJSON)),
        'personTraversal': UserHostGraphTraversalResponseToJSON(value['personTraversal']),
        'queryDurationMs': value['queryDurationMs'],
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

